import React, {ReactElement} from 'react';

import {formatNumber} from '../../decision/util';

type Props = {
  value?: number | string;
  unit?: string;
};

const ValueWithUnit = ({value, unit}: Props): ReactElement => {
  const formatted = value === undefined ? '-' : typeof value === 'number' ? formatNumber(value) : value;

  return (
    <p>
      <span className={'font-semibold'}>{formatted}</span>{' '}
      {value !== undefined && unit !== undefined && <span>{unit}</span>}
    </p>
  );
};

export default ValueWithUnit;
